module.exports = __webpack_public_path__ + "static/media/edit.a954e202.svg";